import {
  // FETCH_ORDER_TRANSACTION,
  FETCH_ALL_ORDER_TRANSACTION,
  // ADD_ORDER_TRANSACTION,
  // ADD_ORDER_TRANSACTION_SUCCEED,
  // ADD_ORDER_TRANSACTION_FAILED,
  // EDIT_ORDER_TRANSACTION,
  // EDIT_ORDER_TRANSACTION_SUCCEED,
  // EDIT_ORDER_TRANSACTION_FAILED,
  // DEL_ORDER_TRANSACTION,
  // DEL_ORDER_TRANSACTION_SUCCEED,
  // DEL_ORDER_TRANSACTION_FAILED,
  FETCH_ALL_ORDER_TRANSACTION_SUCCEED,
  // FETCH_ORDER_TRANSACTION_FAILED,
  // FETCH_ORDER_TRANSACTION_SUCCEED,
  FETCH_ALL_ORDER_TRANSACTION_FAILED,
  FETCH_USER_ORDER_TRANSACTIONS,
  FETCH_USER_ORDER_TRANSACTIONS_SUCCEED,
  FETCH_USER_ORDER_TRANSACTIONS_FAILED,
  FETCH_ID_ORDER_TRANSACTIONS,
  FETCH_ID_ORDER_TRANSACTIONS_SUCCEED,
  FETCH_ID_ORDER_TRANSACTIONS_FAILED,
} from './action_types';

export default {
  fetchAllOrderTransactionAction: (data) => ({
    type: FETCH_ALL_ORDER_TRANSACTION,
    params: {
      data,
    },
  }),

  fetchAllOrderTransactionActionSucceed: (data) => ({
    type: FETCH_ALL_ORDER_TRANSACTION_SUCCEED,
    params: {
      data,
    },
  }),
  fetchAllOrderTransactionActionFailed: (err) => ({
    type: FETCH_ALL_ORDER_TRANSACTION_FAILED,
    err,
  }),

  fetchUserOrderTransactionsAction: (data, callback) => ({
    type: FETCH_USER_ORDER_TRANSACTIONS,
    params: {
      data,
    },
    callback,
  }),

  fetchUserOrderTransactionsActionSucceed: (data) => ({
    type: FETCH_USER_ORDER_TRANSACTIONS_SUCCEED,
    params: {
      data,
    },
  }),
  fetchUserOrderTransactionsActionFailed: (err) => ({
    type: FETCH_USER_ORDER_TRANSACTIONS_FAILED,
    err,
  }),

  fetchIdOrderTransactionsAction: (data, callback) => ({
    type: FETCH_ID_ORDER_TRANSACTIONS,
    params: {
      data,
    },
    callback,
  }),

  fetchIdOrderTransactionsActionSucceed: (data) => ({
    type: FETCH_ID_ORDER_TRANSACTIONS_SUCCEED,
    params: {
      data,
    },
  }),
  fetchIdOrderTransactionsActionFailed: (err) => ({
    type: FETCH_ID_ORDER_TRANSACTIONS_FAILED,
    err,
  }),

};
